<template>
  <section>
    <h5>Ваш уникальный код: {{ currentUser.id }}</h5>
    <qrcode
      :value="`${api_url}/pay/${currentUser.id}`"
      :options="{ width: 250 }"
      tag="canvas"
      ref="qr_canvas"
      class="shadow"
    ></qrcode>
    <div class="mt-6">
      <vs-button @click="downloadQR">Скачать</vs-button>
      &emsp;
      <vs-button
        color="primary"
        type="flat"
        :href="paymentUrl"
        target="_blank"
        @click="handleTrack('toPayPage')"
      >
        страница оплаты
      </vs-button>
    </div>
  </section>
</template>

<script>
import {
  API_URL
} from '@/common/config'
import {
  mapGetters
} from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentUser']),
    api_url() {
      return API_URL
    },
    paymentUrl() {
      return `${this.api_url}/pay/${this.currentUser.id}`
    }
  },
  methods: {
    downloadQR() {
      const img = this.$refs.qr_canvas.$el.toDataURL('image/png')
      const link = document.createElement('a')
      link.href = img
      link.download = 'QR-code.png'
      link.click()
      this.handleTrack('Download')
    },
    handleTrack(label) {
      this.$km_track('EmpQR', 'Click', label)
    }
  }
}
</script>

<style lang="css" scoped>
img, canvas {
  margin: auto;
}
</style>
